<template>
  <div class="w-full">
    <heading title="Subscribe" />
    <SubscribeForm :key="listId" :list-id="listId" />
  </div>
</template>

<script setup>
const route = useRoute()

const SUBSCRIPTION_LIST_IDS = {
  blogs: 8,
  newsletters: 8,
  'live events': 13,
  'student research': 25,
}

const subscriptionContent = computed(() =>
  typeof route.query.content === 'string' ? route.query.content.toLowerCase() : ''
)
const listId = computed(
  () => SUBSCRIPTION_LIST_IDS[subscriptionContent.value] ?? SUBSCRIPTION_LIST_IDS.newsletters
)
const title = 'Subscribe'
const description = 'Subscribe for the latest news, resources, and events from SATS.'

useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description,
  twitterTitle: title,
  twitterDescription: description,
})
</script>
